/** DataTable — dense row list per "density over decoration". */

import { ReactNode } from "react";

export interface Column<T> {
  header: string;
  render: (row: T) => ReactNode;
  className?: string;
}

export default function DataTable<T>({ columns, rows, empty, onRowClick }: { columns: Column<T>[]; rows: T[]; empty?: string; onRowClick?: (row: T) => void }) {
  if (!rows.length) {
    return <div className="text-body-sm text-text-dim py-3">{empty ?? "No rows."}</div>;
  }
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-body-sm">
        <thead>
          <tr className="text-left text-caption uppercase tracking-wide text-text-dim border-b border-strong">
            {columns.map((c, i) => (
              <th key={i} className={`py-2 pr-4 font-medium ${c.className ?? ""}`}>{c.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, ri) => (
            <tr key={ri} onClick={onRowClick ? () => onRowClick(row) : undefined}
              className={`border-b last:border-b-0 hover:bg-surface-hover transition-colors ${onRowClick ? "cursor-pointer" : ""}`}>
              {columns.map((c, ci) => (
                <td key={ci} className={`py-2 pr-4 align-top ${c.className ?? ""}`}>{c.render(row)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
